import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function CropBandView({ onClose, open, prodd }) {
  const navigate = useNavigate();

  const items1 = [
    {
      key: "1",
      label: "Crop Name",
      children: prodd?.cropName ?? "N/A",
    },
    {
      key: "5",
      label: "Status",
      children: prodd?.countyName ?? "N/A",
    },
    {
      key: "2",
      label: "County",
      children: prodd?.countyCode ?? "N/A",
    },
    {
      key: "3",
      label: "Subcounty",
      children: prodd?.subCountyCode ?? "N/A",
    },
    {
      key: "4",
      label: "Location",
      children: prodd?.locLocation ?? "N/A",
    }, 
    {
      key: "45",
      label: "Constituency",
      children: prodd?.constName ?? "N/A",
    },
    {
      key: "4",
      label: "Ward",
      children: prodd?.wdWard ?? "N/A",
    },
    {
      key: "6",
      label: "Latitudes",
      children: prodd?.cropLat ?? "N/A",
    },
    {
      key: "7",
      label: "Longitudes",
      children: prodd?.cropLong ?? "N/A",
    },
     
    {
      key: "9",
      label: "Size (Acres)",
      children: prodd?.cropSize ?? "N/A",
    },
    {
      key: "10",
      label: "Slope of The Ground",
      children: prodd?.cropGroundSlope ?? "N/A",
    },
    {
      key: "11",
      label: "Area under cultivation",
      children: prodd?.cropCultivationArea ?? "N/A",
    },
    {
      key: "12",
      label: "Maximum height of the bund",
      children: prodd?.cropMaxBandHeight ?? "N/A",
    },
    {
      key: "13",
      label: "Maximum Depth of Water",
      children: prodd?.cropMaxWaterDepth ?? "N/A",
    },
    {
      key: "14",
      label: "Catchment Area",
      children: prodd?.cropCatchmentArea ?? "N/A",
    },
    {
      key: "14",
      label: "Crops type (Proposed/Existing)",
      children: prodd?.cropCrops ?? "N/A",
    },
    {
      key: "15",
      label: "Pathways",
      children: prodd?.cropPathways ?? "N/A",
    },
    
    
  ];

  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Trapezoidal Bund For Crops Details</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title="Details"
          column={2}
          colon={false}
          items={items1}
          layout="vertical"
        />
      </div>
    </Drawer>
  );
}

export default CropBandView;
